module.exports = __webpack_public_path__ + "static/media/euro6000.dfbb4821.gif";